module.exports = __webpack_public_path__ + "static/media/O.3df0b94a.png";